import {
  Component,
  Input,
  AfterViewInit,
  OnInit,
  input,
  output,
  viewChild,
} from '@angular/core';
declare const window: any;

@Component({
    selector: 'app-audio-controller',
    templateUrl: './audio-controller.component.html',
    imports: []
})
export class AudioControllerComponent implements AfterViewInit, OnInit {
  window: any = window;
  timeout: any;
  startTransition: any;
  interval: any;
  list: string;

  /** Programmatically buttons. */
  readonly playButton = input(false);
  readonly pauseButton = input(false);
  readonly selectableButton = input(false);
  readonly muteButton = input(false);
  /** Array of audio tracks.*/
  readonly src = input<Array<string>>([]);
  /** Display or not the controls, default: truea */
  readonly controls = input(true);
  /** Set autoplay status, default true. */
  readonly autoplay = input(false);
  /** Set loop status, default false. */
  readonly loop = input(false);
  /** Set the volume, default: 1 (max). */
  readonly volume = input(1);
  /** Set the start index of the playlist. */
  @Input() startPosition = 0;
  /** Number in s, in order to start the transition, default: 5s */
  readonly transition = input(5);
  /** Interval in order to set the audio transition, in ms, default: 500ms. */
  readonly intervalTransition = input(500);
  /** Define if transition, default: false. */
  readonly transitionEnd = input(true);
  /** Define the preload status, default metadata. */
  readonly transitionStart = input(false);
  /** Define the preload status, default metadata. */
  readonly preload = input('metadata');
  /** Define the mute status, default false. */
  readonly muted = input(false);
  /**
   * Custom events who could be intercepted.
   */
  /** Emit the playlist. */
  readonly playlist = output<any>();
  /** Emit informations on the current video. */
  readonly current = output<any>();
  /** Emit downloading status of track. */
  readonly audioDownloading = output<boolean>();

  readonly player = viewChild<any>('audioplayer');

  constructor(
  ) { }

  ngOnInit() {
    /** Init player with the first occurrence of src's array. */
    const src = this.src();
    if (src.length) { this.list = src[this.startPosition];
    }
  }

  ngAfterViewInit() {
    if (this.transitionEnd()) {
      this.player().nativeElement.addEventListener('play', () =>
        this.audioTransition(this.player().nativeElement.duration, this.player().nativeElement.currentTime
      ));
    }

    this.player().nativeElement.addEventListener('ended', () => {
      /** Increment array position in order to get next audio track. */
      this.startPosition += 1;
      /** If loop is true && startPosition is at last index then reset the playlist. */
      const loop = this.loop();
      if (this.startPosition >= this.src().length && loop) {
        this.startPosition = 0;
      }
      /** Else stop the playlist. */
      if (this.startPosition >= this.src().length && !loop) {
        return;
      }

      /** Set new src track */
      this.player().nativeElement.src = this.src()[this.startPosition];
      /** If onChangeTrack is set, then emit the new track. */

    });

    this.player().nativeElement.addEventListener('loadstart', () => {
      this.emitCurrentTrack();

      if (this.transitionStart()) {
        this.audioStartTransition(this.intervalTransition());
      }
    });

    this.player().nativeElement.addEventListener('pause', () => {
      /** Reset Timeout && Interval. */
      this.window.clearTimeout(this.timeout);
      this.window.clearInterval(this.interval);
    });

    this.player().nativeElement.addEventListener('progress', (data: any) => this.audioDownloading.emit(true));
  }
  /** Set programmatically audio controls. */
  play(): void {
    this.player().nativeElement.play();
  }

  pause(): void {
    this.player().nativeElement.pause();
  }

  muteVideo(): void {
    this.player().nativeElement.muted = !this.player().nativeElement.muted;
  }

  previousTrack() {
    /** If first track, then do nothing. */
    if (this.src().indexOf(this.player().nativeElement.src) <= 0) { return; }
    /** Else go back to previous element in track's array. */
    this.player().nativeElement.src = this.src()[this.src().indexOf(this.player().nativeElement.src) - 1];
  }

  nextTrack(): void {
    /** If last track, then do nothing. */
    if (this.src().indexOf(this.player().nativeElement.src) >= this.src().length - 1) { return; }

    /** Else, go to the next element in track's array. */
    this.player().nativeElement.src = this.src()[this.src().indexOf(this.player().nativeElement.src) + 1];
  }

  /** Audio Transitions */

  /** Set transition audio. */
  audioTransition(trackDuration: number, timeElapsed: number = 0): void {
    /** Clear setInterval if defined. */
    this.window.clearInterval(this.interval);
    /** Check the currentTime elapsed, then set transition if defined. */
    this.timeout = this.setTimeoutDelay(trackDuration, timeElapsed);
  }

  audioStartTransition(interval: number): void {
    /** Start the transition. */
    this.startTransition = this.setIncrementInterval(interval);
  }

  setTimeoutDelay(trackDuration: number, timeElapsed: number): any {
    /** Timeout who correspond to the remaining time of audio player without the transition's time ( by default 5s before the end). */
    return setTimeout(() => {
      this.interval = this.setDecrementInterval(this.intervalTransition());
    }, (trackDuration - timeElapsed) * 1000 - (this.transition() * 1000));
  }

  setIncrementInterval(interval: number): any {
    return setInterval(() => {
        this.window.clearInterval(this.startTransition);
    }, interval);
  }

  setDecrementInterval(interval: number): any {
    return setInterval(() => {
    }, interval);
  }

  /**
   * Emitters
   */
  emitPlayList(): void {
    this.playlist.emit(this.src());
  }

  emitCurrentTrack(): void {
    /**
     * Return an object who will contain: Url of the track, duration, textTrack, volume)
     */
    this.current.emit({
      src: this.player().nativeElement.currentSrc,
      textTracks: this.player().nativeElement.textTracks,
      volume: this.player().nativeElement.volume
    });
  }
}

